/**
 * Class for creating of dialog configurations for information dialogs.
 * Dialog receives "data" and the rest is up the details for individual dialogs.
 */
import {MatDialogConfig} from '@angular/material/dialog';
import {DialogType} from '../constants/dialog-type';

export class DialogConfigurationUtils {
  /**
   * Warning details for error dialogs.
   * @param message Error message (label)
   */
  public static error(message: string): MatDialogConfig {
    const config = new MatDialogConfig();
    config.data = DialogConfigurationUtils.createData('warning', 'failedDialogTitle', message);
    config.disableClose = true;
    return config;
  }

  /**
   * Warning details for security error dialogs.
   * @param message Error message (label)
   */
  public static security(message: string): MatDialogConfig {
    const config = new MatDialogConfig();
    config.data = DialogConfigurationUtils.createData('security', 'security', message);
    config.disableClose = true;
    return config;
  }

  /**
   * Warning details for security error dialogs.
   * @param message Error message (label)
   * @param title Dialog title (label)
   */
  public static info(message: string, title: string): MatDialogConfig {
    const config = new MatDialogConfig();
    config.data = DialogConfigurationUtils.createData('info', title, message);
    config.disableClose = true;
    return config;
  }

  public static processing(): MatDialogConfig{
    const config = new MatDialogConfig();
    config.disableClose = true;
    config.id = DialogType.PROCESSING;
    config.data = {label: 'processing'};

    return config;
  }

  /**
   * Creates "data" for error-information dialog
   * @param icon Dialog's icon (mat icon)
   * @param title Dialog's title (label)
   * @param message Dialog's error message (label)
   */
  public static createData(icon: string, title: string, message: string) {
    return {title, icon, message};
  }
}
